import { jsx } from 'react/jsx-runtime';
import { forwardRef, useState, useMemo, useEffect } from 'react';
import { styled } from 'styled-components';
import { renderAst } from '../utils/ast.js';
import { mergeRefs } from 'react-merge-refs';
import { useReferencedFn } from '@fabric-app/hooks/useReferencedFn';

const Wrapper = styled.code.withConfig({
  displayName: "CodeRenderChunk__Wrapper",
  componentId: "sc-a53105b7-0"
})([
  `width:100%;position:absolute;top:0;left:0;`
]);
const CodeRenderChunk = /* @__PURE__ */ forwardRef(({ ast, top, onRender, onUnmount, ...props }, ref) => {
  const [wrapperRef, setWrapperRef] = useState(null);
  const mergedRefs = useMemo(() => mergeRefs([
    ref,
    setWrapperRef
  ]), [
    ref
  ]);
  const onRenderRef = useReferencedFn(onRender);
  const onUnmountRef = useReferencedFn(onUnmount);
  useEffect(() => {
    if (!wrapperRef) return;
    onRenderRef.current?.(wrapperRef);
    return () => {
      onUnmountRef.current?.(wrapperRef);
    };
  }, [
    onRenderRef,
    onUnmountRef,
    wrapperRef
  ]);
  return /* @__PURE__ */ jsx(Wrapper, {
    ref: mergedRefs,
    style: {
      transform: `translateY(${top}px)`,
      ...props.style
    },
    className: "hljs",
    ...props,
    children: renderAst(ast.children)
  });
});
CodeRenderChunk.displayName = "Chunk";

export { CodeRenderChunk };
//# sourceMappingURL=CodeRenderChunk.js.map
